<template>
  <section
    id="_tlqn_admin_sample_group_page"
    class="bg-grey-1 q-pa-md column relative-position"
  >
    <!-- 搜索 -->
    <q-input v-model="search" dense filled label="搜索">
      <template v-slot:append>
        <q-icon name="fas fa-search" size="12px" />
      </template>
    </q-input>

    <q-scroll-area class="col-grow column q-my-md">
      <!-- loading -->
      <Loading v-if="loading" class="q-mt-xl" />
      <q-list v-else-if="filteredGroups.length" class="q-px-sm">
        <q-item
          style="min-height: 42px !important;"
          v-for="group in filteredGroups"
          :key="group.id"
          :title="group.description"
          clickable
          class="row items-center admin-sample-group-li q-mb-sm"
          :to="{
            query: {
              _sg: group.id,
            },
          }"
          :class="{
            'admin-sample-group-li-active': group.id === $route.query._sg,
          }"
        >
          <span class="ellipsis">
            {{ group.name }}
          </span>
        </q-item>
      </q-list>

      <Empty class="q-mt-xl" v-else />
    </q-scroll-area>

    <q-btn
      @click="showCreateGroupDialog = true"
      flat
      class="bg-primary text-white shadow-2"
      :disable="showCreateGroupDialog"
    >
      <q-icon name="fas fa-plus-circle" size="12px" class="q-mr-sm" />
      <span>新建样本组</span>
    </q-btn>

    <!-- 新建 -->
    <q-dialog persistent v-model="showCreateGroupDialog">
      <CreateGroupForm
        @cancel="() => (showCreateGroupDialog = false)"
        @beforeCreate="loading = true"
        @error="loading = false"
        @created="fetchSampleGroupList()"
      />
    </q-dialog>

    <LockMask
      v-if="adminStatusStore[REMOVING_GROUP_MEMBERS]"
      lock-tip="正在操作样本组内的样本"
    />
  </section>
</template>

<script>
import { EventBus } from "@/bus/index";
import { SAMPLE_GROUP_DETAIL_CHANGED } from "@/bus/admin.events";
import { getSampleGroupList } from "@/api/endpoints/sample-group/getSampleGroupList";
import { REMOVING_GROUP_MEMBERS } from "@/status/admin.status";
import AdminCommonStatus from "../../mixins/status.mixin";
export default {
  mixins: [AdminCommonStatus],
  components: {
    LockMask: () => import("@/components/Mask"),
    Empty: () => import("@/components/Empty"),
    Loading: () => import("@/components/Loading"),
    CreateGroupForm: () => import("./CreateGroupForm"),
  },

  data() {
    return {
      loading: false,
      search: "",
      sampleGroups: null,
      showCreateGroupDialog: false,
      REMOVING_GROUP_MEMBERS,
    };
  },

  computed: {
    filteredGroups() {
      const { sampleGroups, search } = this;
      const groups =  (sampleGroups || []).filter((g) => g.name.indexOf(search) > -1);
      groups.sort((g1, g2) => {
        return parseFloat(g1.name) - parseFloat(g2.name)
      });
      return groups;
    },
  },

  mounted() {
    this.fetchSampleGroupList();
    EventBus.$on(SAMPLE_GROUP_DETAIL_CHANGED, this.fetchSampleGroupList);
  },
  beforeDestroy() {
    EventBus.$off(SAMPLE_GROUP_DETAIL_CHANGED, this.fetchSampleGroupList);
  },
  methods: {
    /**
     * 获取样本组列表
     */
    async fetchSampleGroupList() {
      this.loading = true;
      try {
        const res = await getSampleGroupList();
        if (res.status || res.error) {
          this.$q.notify({
            type: "danger",
            message: res.detail || res.message,
          });
        } else {
          this.sampleGroups = res;
          if (!this.$route.query._sg) this.selectDefault();
        }
      } catch (err) {
        console.log(err);
        this.$q.notify({
          type: "danger",
          message: "获取样本组列表出现未知错误",
        });
      } finally {
        this.loading = false;
      }
    },

    selectDefault() {
      if (!this.sampleGroups.length) return;
      this.$router.replace({
        query: { _sg: this.sampleGroups[0].id },
      });
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/quasar";

#_tlqn_admin_sample_group_page {
  .scroll {
    flex-grow: 1;
  }
}
.admin-sample-group-li {
  color: #000 !important;
}
.admin-sample-group-li-active {
  color: $primary !important;
  font-weight: bold;
  background-color: #fff;
  box-shadow: $shadow-1;
}
</style>
